import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';
import Overlay from '../Miscelania/Overlay';
import Topo from '../Layout/Topo';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import FlightReportRefuelsEdit from './FlightReportRefuelsEdit';

class FlightReportRefuelsAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      approval_required: 0,
      export_required: 0,
      aircraft_id: '',
      date: '',
      flight_report_id: '',
      flight_report_leg_id: '',
      fuel_supplier_id: '',
      location_id: '',
      quantity: '',
      receit: '',
      requested: '',
      address: '',
      staff_id: '',
      fueling_started: '',
      fueling_finished: '',
      next_location_id: '',
      hydrant_no: '',
      your_sale_no: '',
      previous_sale_no: '',
      reading_finish: '',
      reading_start: '',
      fuel_type: '',
      fuel_type_id: '',
      aircrafts_select: [],
      flight_reports_select: [],
      flight_report_legs_select: [],
      locations_select: [],
      flight_report_legs: [],
      flight_report_refuels: [],
      flight_report_refuels_table: [],
      ptbr_fuels_select: [],
      fuel_suppliers_select: [],
      fuel_types_select: [],
      companies_select: [],
      staff_select: [],
      flight_report_refuel_edit: {},
      modal_locations_select: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.updateData = this.updateData.bind(this);
    this.updateDataByModal = this.updateDataByModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleChangeGallonsReading (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    
    if (name == 'reading_start') {
      var start = event.target.value;
    } else {
      var start = this.state.reading_start;
    }
    if (name == 'reading_finish') {
      var finish = event.target.value;
    } else {
      var finish = this.state.reading_finish;
    }
    var delivered = (parseInt(finish) - parseInt(start));
    this.setState({quantity: delivered});
  }
  handleExtraFlightToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeReport(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var self = this;
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');

      change['requested'] = '';
      change['receit'] = '';
      change['quantity'] = '';
      
      if(self.state.flight_report_legs[event.value]) {
          change['flight_report_legs_select'] = self.state.flight_report_legs[event.value];
      } else {
          change['flight_report_legs_select'] = [];
      }
      if(self.state.flight_report_refuels[event.value]) {
        change['flight_report_refuels_table'] = self.state.flight_report_refuels[event.value];
      } else {
        change['flight_report_refuels_table'] = [];
      }
      
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/basic/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.aircraft_id,
            fuel_type_id: responseJson.data.aircraft.aircraft_model.fuel_type_id,
          });
          self.handleSelectChangeFuelType('fuel_type_id', {'value': self.state.fuel_type_id});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.main.id,
            fuel_type_id: responseJson.data.main.aircraft_model.fuel_type_id,
          });
          self.handleSelectChangeFuelType('fuel_type_id', {'value': self.state.fuel_type_id});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelType(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/tipo/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            fuel_type: responseJson.data.abbreviation,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            locations_select: responseJson.data.locations_select,
            location_id: responseJson.data.flight_report_leg.departure_location_id,
            next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
            reading_start: responseJson.data.flight_report_leg.fuel_start
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            approval_required: responseJson.data.main.refuel_approval_required,
            export_required: responseJson.data.main.refuel_export_required,
            staff_id: '',
            requested: '',
            receit: '',
            quantity: '',
            address: '',
            staff_id: '',
            fueling_started: '',
            fueling_finished: '',
            next_location_id: '',
            hydrant_no: '',
            your_sale_no: '',
            previous_sale_no: '',
            reading_finish: '',
            reading_start: '',
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  updateData() {
    var change = {};
    if(this.state.flight_report_refuels[this.state.flight_report_id]) {
        change['flight_report_refuels_table'] = this.state.flight_report_refuels[this.state.flight_report_id];
    } else {
        change['flight_report_refuels_table'] = [];
    }
    this.setState(change);
  }

  updateDataByModal(responseJson) {
    this.setState({ 
      flight_reports_select: responseJson.data.infos.flight_reports_select,
      flight_report_legs: responseJson.data.infos.flight_report_legs_select,
      flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
      fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
      fuel_types_select: responseJson.data.infos.fuel_types_select,
      companies_select: responseJson.data.infos.companies_select,
      staff_select: responseJson.data.infos.staff_select
    });
    this.updateData();
    this.handleAlert(responseJson.message, responseJson.status, 'open');
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/abastecimento/listas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            locations_select: responseJson.data.locations_select,
            flight_reports_select: responseJson.data.flight_reports_select,
            flight_report_legs: responseJson.data.flight_report_legs_select,
            flight_report_refuels: responseJson.data.flight_report_refuels,
            fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
            fuel_types_select: responseJson.data.fuel_types_select,
            companies_select: responseJson.data.companies_select,
            staff_select: responseJson.data.staff_select
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    var datasave = new FormData();
    var imagedata = document.querySelector(".input-nf-file").files[0];
    datasave.append("aircraft_id", this.state.aircraft_id);
    datasave.append("date", this.state.date);
    datasave.append("flight_report_id", this.state.flight_report_id);
    datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
    datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
    datasave.append("location_id", this.state.location_id);
    datasave.append("receit", this.state.receit);
    datasave.append("requested", this.state.requested);
    datasave.append("quantity", this.state.quantity);
    datasave.append("file", imagedata);
    datasave.append("address", this.state.address);
    datasave.append("staff_id", this.state.staff_id);
    datasave.append("fueling_started", this.state.fueling_started);
    datasave.append("fueling_finished", this.state.fueling_finished);
    datasave.append("next_location_id", this.state.next_location_id);
    datasave.append("hydrant_no", this.state.hydrant_no);
    datasave.append("your_sale_no", this.state.your_sale_no);
    datasave.append("previous_sale_no", this.state.previous_sale_no);
    datasave.append("reading_finish", this.state.reading_finish);
    datasave.append("reading_start", this.state.reading_start);
    datasave.append("fuel_type_id", this.state.fuel_type_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/abastecimento', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: datasave }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/abastecimento/editar/' + responseJson.data.flight_report_refuel.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.updateData();
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (id) {
    if (window.confirm(this.locale.RelatorioAbastecimento.AdicionarAbastecimento.deletar)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ 
            aircrafts_select: responseJson.data.infos.aircrafts_select,
            locations_select: responseJson.data.infos.locations_select,
            flight_reports_select: responseJson.data.infos.flight_reports_select,
            flight_report_legs: responseJson.data.infos.flight_report_legs_select,
            flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
            fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
            fuel_types_select: responseJson.data.infos.fuel_types_select,
            companies_select: responseJson.data.infos.companies_select,
            staff_select: responseJson.data.infos.staff_select,
            aircraft_id: '',
            date: '',
            flight_report_id: '',
            flight_report_leg_id: '',
            fuel_supplier_id: '',
            location_id: '',
            receit: '',
            requested: '',
            quantity: '',
            address: '',
            staff_id: '',
            fueling_started: '',
            fueling_finished: '',
            next_location_id: '',
            hydrant_no: '',
            your_sale_no: '',
            previous_sale_no: '',
            reading_finish: '',
            reading_start: '',
            fuel_type_id: '',
          });
          self.updateData();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openEditModal (id) {
    var self = this;
    Object.keys(this.state.flight_report_refuels_table).map(function(k) {
      if(self.state.flight_report_refuels_table[k].id == id) {
        var flight_report_leg_id = self.state.flight_report_refuels_table[k].flight_report_leg_id;
        var flight_report_refuel_edit = self.state.flight_report_refuels_table[k];
        var fuel_supplier_id = self.state.flight_report_refuels_table[k].fuel_supplier.id;
        var header = self.refs.request_api.header('application/json');
        self.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              modal_locations_select: responseJson.data.locations_select, 
              modal_location_id: responseJson.data.location_id,
              fuel_supplier_id: fuel_supplier_id,
              flight_report_refuel_edit: flight_report_refuel_edit,
              modal: true,
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
    });
  }

  closeModal(responseJson) {
    this.setState({
      modal: false,
      flight_report_refuel_edit: {},
    });
    this.updateData();
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;

    this.setState(change);
  }

  formFields(fields_type) {

    var fields = '';

    if (fields_type == 0) {
      fields = (
        <div className="row">
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado}:</label>
              <InputMask value={this.state.requested}  maskChar={null} name="requested " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDaCe}:</label>
              <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelAbastecido}:</label>
              <InputMask value={this.state.quantity}  maskChar={null} name="quantity " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="" required/>
          </div>
        </div>
      );
    } else {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comandante}</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_select}
                />
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.InicioAbastecimento}:</label>
                <InputMask value={this.state.fueling_started}  maskChar={null} name="fueling_started " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_started')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_started')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TerminoAbastecimento}:</label>
                <InputMask value={this.state.fueling_finished}  maskChar={null} name="fueling_finished " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_finished')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_finished')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.ProximaLocalidade}:</label>
                <Select
                  className="form-field-name"
                  name="next_location_id"
                  value={this.state.next_location_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                  options={this.state.locations_select}
                  required
                />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroHidrante}:</label>
                <input type="number" name="hydrant_no" className="form-control" placeholder="999" value={this.state.hydrant_no} onChange={this.handleChange.bind(this, 'hydrant_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.SeuNumeroDeVenda}:</label>
                <input type="text" name="your_sale_no" className="form-control" placeholder="" value={this.state.your_sale_no} onChange={this.handleChange.bind(this, 'your_sale_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDeVendaAnterior}:</label>
                <input type="text" name="previous_sale_no" className="form-control" placeholder="" value={this.state.previous_sale_no} onChange={this.handleChange.bind(this, 'previous_sale_no')} required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraFinal}:</label>
                <input type="number" name="reading_finish" className="form-control" placeholder="999" value={this.state.reading_finish} onChange={this.handleChangeGallonsReading.bind(this, 'reading_finish')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraInicial}:</label>
                <input type="number" name="reading_start" className="form-control" placeholder="999" value={this.state.reading_start} onChange={this.handleChangeGallonsReading.bind(this, 'reading_start')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Entregues}:</label>
                <InputMask value={this.state.quantity}  maskChar={null} name="quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="9999" required/>
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeFuelType.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                />
            </div>
          </div>
        </div>
      );
    }

    return fields;

  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.titulo}</h3>
        <Link to="/abastecimentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.add}>
            <div className="row">
              <div className="col-md-6 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Fornecedor}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_supplier_id"
                  value={this.state.fuel_supplier_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
                  options={this.state.fuel_suppliers_select}
                  required
                />
              </div>
              <div className="col-md-6 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AnexarNotaFiscal}:</label>
                <input type="file" name="file" className="form-control input-nf-file" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Relatorio}:</label>
                  <Select
                      className="form-field-name"
                      name="flight_report_id"
                      value={this.state.flight_report_id}
                      searchable={true}
                      placeholder={'Selecione'}
                      onChange={this.handleSelectChangeReport.bind(this, 'flight_report_id')}
                      options={this.state.flight_reports_select}
                      required
                  />
              </div>
              <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Trecho}:</label>
                  <Select
                      className="form-field-name"
                      name="flight_report_leg_id"
                      value={this.state.flight_report_leg_id}
                      searchable={true}
                      placeholder={'Selecione'}
                      onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
                      options={this.state.flight_report_legs_select}
                      required
                  />
              </div>
              <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade}:</label>
                  <Select
                    className="form-field-name"
                    name="location_id"
                    value={this.state.location_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'location_id')}
                    options={this.state.locations_select}
                    required
                  />
              </div>
            </div>
            {this.formFields(this.state.export_required)}
            <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.botaoAdicionarAbastecimento}</button>
        </form>
        {this.state.flight_report_id ? 
            <div className="table-responsive">
                <hr/>
                <table className="table table-bordered table-hover table-striped">
                    <thead>
                        <tr>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Trecho}</th>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.NumeroDaCe}</th>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Fornecedor}</th>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Localidade}</th>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.QuantidadeSolicitada}</th>
                        <th>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.QuantidadeAbastecida}</th>
                        <th className="col-md-1 text-center">{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Acoes}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {Object.keys(self.state.flight_report_refuels_table).map(function(k) {
                        var srr = self.state.flight_report_refuels_table[k];
                        return (
                        <tr key={srr.id}>
                            <td>
                            {(srr.flight_report_leg === null ) ? '' :
                            <span>{srr.flight_report_leg.leg_number}</span>
                            }
                            </td>
                            <td>{srr.receit}</td>
                            <td>
                              {(srr.fuel_supplier === null ) ? '' :
                                <span>{srr.fuel_supplier.name}</span>
                              }
                            </td>
                            <td>
                              {(srr.location === null ) ? '' :
                                <span>{srr.location.name}</span>
                              }
                            </td>
                            <td>{srr.requested} {self.state.fuel_type}</td>
                            <td>{srr.quantity} L</td>
                            <td className="text-center">
                                <Link to={"/abastecimento/editar/" + srr.id} className="btn btn-primary btn-sm button-inline"><i className="fa fa-pencil"></i></Link>
                                <button onClick={() => self.delete(srr.id)} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                            </td>
                        </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        
        : ''
        }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsAdd;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsAdd.js